import { useTxGuard } from '@cronos-app/components';
import {
  type ChainId,
  ChainLayer,
  getRelatedCronosEvmChain,
  getRelatedL2Chain,
} from '@cronos-app/sdk';
import { currentWallet } from '@cronos-app/wallet';
import { useCallback } from 'react';

export const useTxGuardFn = (chainId: ChainId) => {
  return useTxGuard(async (context) => context, chainId);
};

export const useChainLayerGuardFn = () => {
  const desiredNetwork = currentWallet.useDesiredNetwork();
  const guardL1 = useTxGuardFn(desiredNetwork);
  const guardL2 = useTxGuardFn(getRelatedL2Chain(desiredNetwork));
  const guardCronosEvm = useTxGuardFn(getRelatedCronosEvmChain(desiredNetwork));

  return useCallback(
    async (chainLayer: ChainLayer) => {
      const guardFn = ((): typeof guardL1 => {
        switch (chainLayer) {
          case ChainLayer.L1:
            return guardL1;
          case ChainLayer.L2:
            return guardL2;
          case ChainLayer.CronosEvm:
            return guardCronosEvm;
        }
      })();

      return guardFn();
    },
    [guardCronosEvm, guardL1, guardL2],
  );
};
